
import React, { useRef } from 'react';
import { Space, Modal, Row, Col, Image } from "antd";
import { MediumFont, NormalFont } from "../../../../../Shared/components/font";
import jsPDF from 'jspdf';
import CloseIcon from "../../../../../../assets/images/icon_menus/Close Button.svg";
import Artboard from "../../../../../../assets/images/currency/Artboard.png";
import { Button } from "@mui/material";
import { ChallanFormat } from "./ChallanFormat";


export const DeliveryChallan = React.forwardRef((props, ref) => {
    const { visible, handleClose, clsx, classes, form } = props;
    const printComponent = useRef(null);

    const handleDownload = async (type = 'download') => {
        const content = printComponent.current;
        const doc = new jsPDF('pt', 'px', 'a4');
        doc.addFileToVFS('Roboto-Regular.ttf', NormalFont);
        doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal');
        doc.addFileToVFS('Roboto-Medium.ttf', MediumFont);
        doc.addFont('Roboto-Medium.ttf', 'RobotoMedium', 'normal');
        doc.setFont("Roboto");
        doc.setFont("RobotoMedium");
        doc.html(content, {
            //fontFaces: fonts,
            callback: function (doc) {
                if (process.env.NODE_ENV === 'development' || process.env.REACT_APP_PRODUCTION_MODE === 'development' || process.env.REACT_APP_PRODUCTION_MODE === 'qa') {
                    doc.addImage(Artboard, 'PNG', 100, doc.internal.pageSize.height - 275, 400, 54, '', '', 45);
                }
                if (type === 'print') {
                    doc.autoPrint();
                    window.open(doc.output('bloburl'));
                } else {
                    doc.save(`Goods-Receipt-${form?.id}`);
                }
            },
            autoPaging: 'text',
            margin: [10, 10, 10, 10],
            html2canvas: {
                scale: 0.433
            } // change the scale to whatever number you need
        });
    };


    return (
        <Modal title="" open={visible} footer={null}
            onCancel={() => handleClose()}
            width={1030}
            closable={false}
            className={clsx(classes.invoiceDesign, classes.removeUnderline)}>
            <Row gutter={75} className={classes.invoiceHeader}>
                <Col span={24} className={clsx(classes.textAlignRight, classes.fontSize0)}>
                    <Space size={[20, 20]} direction="horizontal" align="center">
                        <Button
                            key="confirm"
                            color="primary"
                            variant="contained"
                            onClick={() => handleDownload('print')}
                            className={clsx(classes.AddMoreBtn)}>Print</Button>
                        <Button
                            key="save"
                            color="primary"
                            variant="contained"
                            onClick={() => handleDownload()}
                            className={clsx(classes.modalBtn)}>Download</Button>
                        <Image onClick={() => handleClose()} src={CloseIcon} preview={false} className={classes.cursor} />
                    </Space>
                </Col>
            </Row>
            <div ref={printComponent} className={clsx(classes.divToPrint)} style={{ position: "relative" }}>
                <ChallanFormat
                    details={form}
                    {...props}
                />
            </div>
        </Modal>
    )
});